document.addEventListener("DOMContentLoaded", function() {
/*----------------------------
    Get/Display CEU Values
-----------------------------*/
(function () {
  let ceuDataRaw = '{{ product.variants.first.metafields.ButtonFlag["CEU"] }}';
  let ceuData = JSON.parse(ceuDataRaw);
  
  ceuData.forEach((item) => {
     var ceuSpan = document.createElement("span");
     ceuSpan.innerText = item.shortName + " " + parseFloat(item.ceus).toFixed(2);
  
     document.getElementById("ceuList").append(ceuSpan);
  });
});


/*------------------
    Product Tabs
-------------------*/
//Switch active tab based on URL
window.addEventListener("load", function() {
    $.fn.tabChange = function (){
        var url = window.location.href;
        var urlTabID = url.split('#')[1];
        if(urlTabID){
            var tabID = urlTabID.replace("tab-", "display-");
        }
        //Adds 'tab-content' class if missing
        if ($("div[id^='tab-']").hasClass("tab-content")) {
        } else {
            $( "div[id^='tab-']" ).addClass( "tab-content" );
        }

        // Assigns 'active' class based on the anchor in the URL
        if(window.location.href.indexOf("#" + urlTabID) > -1) {
            $("ul.tabs li a").removeClass("active");
            $("#" + tabID).addClass("active");
            $(".tab-content").hide();
            $("#" + urlTabID).show();

            const scrollTarget = document.getElementById(tabID);
            // Scroll to the element with smooth scroll behavior
            if(scrollTarget){
                scrollTarget.scrollIntoView({ behavior: 'smooth' });
            }
        } else{
        }
    }

    // Runs 'tabChange' function on page load
    $(document).ready(function () {
        $.fn.tabChange();
    });

    // Runs 'tabChange' function when URL changes
    $(window).on('hashchange', function (e){
        $.fn.tabChange();
    });
});

// Assigns 'active' class and hides/shows content for the clicked tab
$('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
        $($(this).attr('href')).hide();
    });
    
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      //return false;
    });
  });
});